import { Box, Grid, Typography, styled, useTheme } from "@mui/material";

import BoxPrice from "./BoxPrice";
import useIsMobileView from "hooks/useIsMobileView";
import { useSelector } from "react-redux";
import FancyCard from "components/FancyCard";
import { DefaultUrlWeb } from "config/Configuration";
import { useMemo } from "react";

function BoxInvestmentFixed() {
  const theme = useTheme()
  const isMobileView = useIsMobileView();

  const fixedInfo = useSelector((state) => state.investment?.investmentFixedInfo?.data)

  const coinImage = useMemo(() => {
    return DefaultUrlWeb + fixedInfo?.lisInfo?.[0]?.coinImageUrl
  }, [fixedInfo])

  return (
    <FancyCard color={theme.palette.primary.alternate}>
      <Grid container spacing={1}>
        <Grid item xs={8}>
          <BoxCoin>
            <Typography
              variant={isMobileView ? "h6" : "h4"}
              color="text.main"
              fontWeight={700}
            >
              Investment Fixed Wallet
            </Typography>

            <img src={coinImage} alt="USDT" />
          </BoxCoin>
        </Grid>

        <Grid item xs={4}>
          <BoxDate>
            <Typography variant="h6" component="span" fontWeight={400}>
              {fixedInfo?.date} <br /> {fixedInfo?.time}
            </Typography>
          </BoxDate>
        </Grid>
      </Grid>

      {fixedInfo?.lisInfo?.map((info) => (
        <Grid container spacing={1}>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <BoxPrice
              title={"Amount:"}
              price={info?.amount}
              coin={info?.coinName}
            />
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <BoxPrice
              title={"Profit/Loss:"}
              price={info?.profitOrLoss}
              amountInterestRates={info?.percent}
              coin={info?.coinName}
            />
          </Grid>

          <Grid item lg={4} md={6} sm={6} xs={12}>
            <BoxPrice
              title={"Total Balance:"}
              price={info?.total}
              coin={info?.coinName}
              isBigValue
            />
          </Grid>
        </Grid>
      ))}
    </FancyCard>
  );
}

const BoxDate = styled(Box)(({ theme }) => ({
  color: `${theme.palette.text.main}`,
  fontWeight: "300",
  fontSize: "12px",
  lineHeight: "18px",
  textAlign: "right",

  small: {
    color: `${theme.palette.text.main}`,
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "18px",
    textAlign: "end",
  },
}));

const BoxCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(4),
  gap: theme.spacing(1),
  img: {
    width: "25px",
  },
}));

export default BoxInvestmentFixed;
